







































































































































































import { Component, Ref, Vue } from 'vue-property-decorator'
import { Inject } from 'inversify-props'
import { obrigatorio } from '@/shareds/regras-de-form'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import type { EtiquetaDePrecoServiceAdapter } from '@/usecases'
import type {
	ConfiguracaoDeLogosDeEtiqueta,
	TipoDeEtiquetaDoPedido,
} from '@/models/ConfiguracaoDeLogosDeEtiqueta'

const PreviewDeLogo = Vue.extend({
	props: {
		url: { type: String, default: '' },
	},
	data() {
		return {
			carregando: false,
			erroAoCarregar: false,
		} as { carregando: boolean; erroAoCarregar: boolean }
	},
	watch: {
		url(novaUrl: string) {
			const self = this as any
			if (novaUrl) {
				self.carregando = true
				self.erroAoCarregar = false
			}
		},
	},
	render(h) {
		const tamanho = 56
		const self = this as any
		const isDark = self.$vuetify.theme.dark

		const cores = {
			placeholder: {
				border: isDark ? '#505050' : '#c4c4c4',
				background: isDark ? '#2c2c2c' : '#fafafa',
			},
			erro: {
				border: isDark ? '#ffb74d' : '#ff9800',
				background: isDark ? '#424242' : '#fff8e1',
				color: isDark ? '#ffb74d' : '#ff9800',
			},
			imagem: {
				border: isDark ? '#424242' : '#e0e0e0',
				background: isDark ? '#1e1e1e' : '#fff',
			},
		}

		const estiloBase = {
			width: `${tamanho}px`,
			height: `${tamanho}px`,
			borderRadius: '6px',
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'center',
			position: 'relative',
		}

		if (!self.url) {
			return h('div', {
				style: {
					...estiloBase,
					border: `2px dashed ${cores.placeholder.border}`,
					background: cores.placeholder.background,
				},
			})
		}

		if (self.erroAoCarregar) {
			return h('div', {
				style: {
					...estiloBase,
					border: `2px solid ${cores.erro.border}`,
					background: cores.erro.background,
					color: cores.erro.color,
					fontFamily: "'Material Icons'",
					fontSize: '24px',
					fontWeight: 'normal',
					fontStyle: 'normal',
					letterSpacing: 'normal',
					textTransform: 'none',
					cursor: 'help',
				},
				class: 'material-icons',
				attrs: {
					title: 'Não conseguiu carregar a imagem (CORS). Será válida na impressão.',
				},
				domProps: { textContent: '?' },
			})
		}

		return h('div', {
			style: {
				...estiloBase,
				position: 'relative',
				border: `1px solid ${cores.imagem.border}`,
				background: cores.imagem.background,
				overflow: 'hidden',
			},
		}, [
			h('img', {
				attrs: { src: this.url, alt: 'logo', crossorigin: 'anonymous' },
				style: {
					width: '100%',
					height: '100%',
					objectFit: 'contain',
					padding: '4px',
				},
				on: {
					load: () => {
						self.carregando = false
						self.erroAoCarregar = false
					},
					error: () => {
						self.carregando = false
						self.erroAoCarregar = true
					},
				},
			}),
			self.carregando ? h('div', {
				style: {
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
					background: 'rgba(255, 255, 255, 0.7)',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				},
			}, [
				h('v-progress-circular', {
					props: { indeterminate: true, size: 24, width: 2, color: 'primary' },
				}),
			]) : null,
		])
	},
})

@Component({
	components: {
		PreviewDeLogo,
	},
})
export default class TelaDeEtiquetaDeEntrega extends Vue {
	@Ref() form!: HTMLFormElement

	@Inject('EtiquetaDePrecoServiceAdapter')
	private etiquetaDePrecoService!: EtiquetaDePrecoServiceAdapter

	obrigatorio = obrigatorio
	salvando = false
	carregando = false

	tiposDeEtiqueta: TipoDeEtiquetaDoPedido[] = ['Correios']

	configuracao: ConfiguracaoDeLogosDeEtiqueta = criarConfiguracao()

	created() {
		this.buscarConfiguracao(this.configuracao.tipoDeEtiquetaDoPedido)
	}

	async buscarConfiguracao(tipoDeEtiquetaDoPedido: TipoDeEtiquetaDoPedido | null) {
		if (!tipoDeEtiquetaDoPedido) return
		try {
			this.carregando = true
			const configuracao = await this.etiquetaDePrecoService
				.findConfiguracaoDeLogosDeEtiqueta(tipoDeEtiquetaDoPedido)
			if (configuracao) {
				this.configuracao = {
					...configuracao,
					condicoes: configuracao.condicoes && configuracao.condicoes.length
						? configuracao.condicoes
						: [{ id: null, tipoDeFrete: '', urlDaLogo: '' }],
				}
			} else {
				this.configuracao = criarConfiguracao(tipoDeEtiquetaDoPedido)
			}
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	urlValida(valor: string): true | string {
		if (!valor) return 'Campo obrigatório'
		try {
			const url = new URL(valor)
			return url.protocol === 'http:' || url.protocol === 'https:'
				? true
				: 'Informe uma URL válida'
		} catch {
			return 'Informe uma URL válida'
		}
	}

	urlValidaOuVazia(valor: string): true | string {
		if (!valor) return true
		return this.urlValida(valor)
	}

	adicionarCondicao() {
		this.configuracao.condicoes.push({
			id: null,
			tipoDeFrete: '',
			urlDaLogo: '',
		})
	}

	removerCondicao(indice: number) {
		this.configuracao.condicoes.splice(indice, 1)
	}

	cancelar() {
		this.form?.resetValidation()
		this.buscarConfiguracao(this.configuracao.tipoDeEtiquetaDoPedido)
	}

	async salvar() {
		try {
			this.salvando = true
			const payload: ConfiguracaoDeLogosDeEtiqueta = {
				...this.configuracao,
				id: this.configuracao.id || null,
				condicoes: this.configuracao.condicoes.map(condicao => ({
					...condicao,
					id: condicao.id || null,
				})),
			}
			const salva = await this.etiquetaDePrecoService
				.salvarConfiguracaoDeLogosDeEtiqueta(payload)

			if (salva) {
				this.configuracao = {
					...salva,
					condicoes: salva.condicoes && salva.condicoes.length
						? salva.condicoes
						: [{ id: null, tipoDeFrete: '', urlDaLogo: '' }],
				}
			}

			AlertModule.setSuccess('Configuração salva com sucesso!')
		} catch (error: any) {
			AlertModule.setError(error?.message || 'Erro ao salvar configuração')
		} finally {
			this.salvando = false
		}
	}
}

function criarConfiguracao(tipoDeEtiquetaDoPedido: TipoDeEtiquetaDoPedido = 'Correios'): ConfiguracaoDeLogosDeEtiqueta {
	return {
		id: null,
		tipoDeEtiquetaDoPedido,
		condicoes: [
			{ id: null, tipoDeFrete: '', urlDaLogo: '' },
		],
		urlDaLogoPadrao: '',
	}
}
